import { render, staticRenderFns } from "./ModalV3.vue?vue&type=template&id=601f42b0&scoped=true"
import script from "./ModalV3.vue?vue&type=script&lang=js"
export * from "./ModalV3.vue?vue&type=script&lang=js"
import style0 from "./ModalV3.vue?vue&type=style&index=0&id=601f42b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601f42b0",
  null
  
)

export default component.exports